<template>
    <v-card color="#ddd" max-width="340" flat tile outlined class="mx-auto pa-30 pa-lg-40">
        <h3 class="tit tit--sm text-center pb-24">사업장</h3>
        <v-row class="row--xxs">
            <v-col v-for="(workplace, index) in workplaces" :key="index" cols="12">
                <p class="page-text page-text--lg line-height-1">· {{ workplace.number }}개 {{ workplace.type }}</p>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
export default {
    data() {
        return {
            workplaces: [
                {
                    type: "아동돌봄시설(키움·돌봄센터)",
                    number: 4,
                },
                {
                    type: "아동보육시설(어린이집)",
                    number: 2,
                },
                {
                    type: "학대피해아동쉼터",
                    number: 2,
                },
                {
                    type: "아동보호전문기관",
                    number: 4,
                },
                {
                    type: "50플러스센터",
                    number: 2,
                },
                {
                    type: "노인종합복지관",
                    number: 2,
                },
                {
                    type: "소규모 노인복지관",
                    number: 1,
                },
                {
                    type: "시니어클럽",
                    number: 5,
                },
                {
                    type: "종합사회복지관",
                    number: 2,
                },
                {
                    type: "지역자활센터",
                    number: 1,
                },
                {
                    type: "장애인주간보호센터",
                    number: 1,
                },
                {
                    type: "치매노인주간보호센터",
                    number: 2,
                },
            ],
        };
    },
};
</script>